<mat-dialog-content>
  <mat-tab-group #tabs (selectedIndexChange)="onSelectedIndexChanged($event)">

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>
          <img src="/assets/icons/dashboard/playlist-item-dialog/Upload.svg">
        </mat-icon> Upload File
      </ng-template>
      <ng-template matTabContent>
        <tab-file appDnd [playlist]="playlist" [launchers]="launchers" [playlistItems]="playlistItems"
          [hasRssForegroundItem]="playlistHasForegroundRss" [oldPlaylistItems]="oldPlaylistItems"
          (closeRequest)="onDialogClose($event)" [(addAnother)]="AddAnother"></tab-file>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>
          <img src="/assets/icons/dashboard/playlist-item-dialog/Recent.svg">
        </mat-icon> Recent Files
      </ng-template>
      <ng-template matTabContent>
        <tab-recent-files [playlistItem]="playlistItems[0]" [(addAnother)]="AddAnother" [playlist]="playlist"
          [launchers]="launchers" [hasRssForegroundItem]="playlistHasForegroundRss"
          (closeRequest)="onDialogClose($event)"></tab-recent-files>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>
          <img src="/assets/icons/dashboard/playlist-item-dialog/Url.svg">
        </mat-icon> Add URL
      </ng-template>
      <ng-template matTabContent>
        <tab-url [playlistItem]="playlistItems[0]" [(addAnother)]="AddAnother" [launchers]="launchers"
          [hasRssForegroundItem]="playlistHasForegroundRss" [playlist]="playlist" [isToSetDefaultLauncher]="true"
          (closeRequest)="onDialogClose($event)"></tab-url>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>
          <img src="/assets/icons/dashboard/playlist-item-dialog/Local.svg">
        </mat-icon> Local
      </ng-template>
      <ng-template matTabContent>
        <tab-local-file [playlistItem]="playlistItems[0]" [launchers]="launchers" [(addAnother)]="AddAnother"
          [playlist]="playlist" [hasRssForegroundItem]="playlistHasForegroundRss"
          (closeRequest)="onDialogClose($event)"></tab-local-file>
      </ng-template>
    </mat-tab>

    @if (isForegroundTabEnabled) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>
            <img src="/assets/icons/dashboard/playlist-item-dialog/picture_in_picture.svg">
          </mat-icon> Foreground
        </ng-template>
        <ng-template matTabContent>
          <tab-foreground-item [playlistItem]="playlistItems[0]" [launchers]="launchers" [(addAnother)]="AddAnother"
            [playlist]="playlist" (closeRequest)="onDialogClose($event)"></tab-foreground-item>
        </ng-template>
      </mat-tab>
    }

  </mat-tab-group>
</mat-dialog-content>
